import { useLocation } from 'react-router-dom'

const useQueryString = (param) => {
  const location = useLocation()
  return new URLSearchParams(location.search).get(param)
}

export default useQueryString
